export enum PaperGenMethodEnum {
    MANUAL = 'MANUAL',
    SYSTEM = 'SYSTEM'
}